import React, { CSSProperties, ComponentType, useEffect, useState } from "react";

type SvgProps = {
  className?: string;
  dataTestId?: string;
  height?: number;
  size?: string | number;
  style?: CSSProperties;
  svgName: string;
  width?: number;
  onClick?: (e: MouseEvent) => void;
};

export const Svg = ({ svgName, height, width, size, className, style, dataTestId, onClick }: SvgProps) => {
  const [ReactSvg, setReactSvg] = useState<ComponentType | null>(null);

  useEffect(() => {
    let unmounted = false;
    async function getData() {
      const module = await import(`!!@svgr/webpack?-svgo,+titleProp,+ref!../../../../assets/${svgName}.svg`);
      if (!unmounted) setReactSvg(module.default);
    }
    getData();
    return () => {
      unmounted = true;
    };
  }, [svgName]);

  return ReactSvg ? (
    // @ts-expect-error height and width are needed here
    <ReactSvg data-testid={dataTestId} width={width || size} height={height || size} className={className} style={style} onClick={onClick} />
  ) : null;
};

export default Svg;
